import type { TableProps } from '@/react_app/components/Atoms';
import { AppTable, AppTag, AppAnchorLink } from '@/react_app/components/Atoms';
import { InvoiceDisplay, InvoiceStatus } from '@/react_app/components/BillingUsage/InvoiceHistory/types';
import { getReadableAmountInDollars } from '@/utils/helpers';
interface TableRow {
	key: string;
	date: string;
	number: string;
	amount: string;
	status: InvoiceStatus;
}

const columns: TableProps<TableRow>['columns'] = [
	{
		key: 'date',
		title: 'Date',
		dataIndex: 'date',
		render: (DateFormatted) => (
			<div className="flex items-center">
				<span className="text-colorText">{DateFormatted}</span>
			</div>
		),
	},
	{
		title: 'Number',
		dataIndex: 'number',
		key: 'number',
		render: (text) => <div className="text-colorTextSecondary">{text}</div>,
	},
	{
		title: 'Amount',
		dataIndex: 'amount',
		key: 'amount',
		render: (amount) => <div className="text-colorTextSecondary">{getReadableAmountInDollars(amount)}</div>,
	},
	{
		title: 'Status',
		dataIndex: 'status',
		key: 'status',
		render: (_, { status }) => {
			let color: string;
			switch (status) {
				case InvoiceStatus.Paid:
					color = 'green';
					break;
				case InvoiceStatus.Rejected:
					color = 'red';
					break;
				case InvoiceStatus.Unpaid:
					color = 'yellow';
					break;
				default:
					color = '';
					break;
			}
			return (
				<AppTag color={color} key={status} className="capitalize">
					{status}
				</AppTag>
			);
		},
	},
	{
		title: 'Download',
		key: 'download',
		dataIndex: 'invoiceUrl',
		render: (invoiceUrl) => (
			<AppAnchorLink href={invoiceUrl} title="Download invoice" className="underline text-colorTextSecondary hover:no-underline" />
		),
	},
];

const SettingsUsageBillingInvoiceHistoryTable = ({ invoices }: { invoices: InvoiceDisplay[] }) => {
	const tableRows: TableRow[] = invoices.map((invoice, i) => ({ ...invoice, key: String(i) }));
	return <AppTable columns={columns} dataSource={tableRows} pagination={false} />;
};

export default SettingsUsageBillingInvoiceHistoryTable;
